import React from "react";
import { useSelector } from "react-redux";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Autoplay, Navigation } from "swiper";
import "./sectionThreeThemeThree.css";

function SectionThreeThemeThree() {
  const homedata: any = useSelector<any>((state) => state?.homeJsonList);
  const section = homedata?.theme_3?.home?.section_3;
  const collection = section?.card_section?.collection || [];
  const isMydhobi = window.location.href.includes("mydhobi");

  const mydhobiContent = [
    [
      {
        label: "Unmatched Quality",
        text: "We treat every garment as if it were our own, using cutting-edge techniques and premium products to deliver flawless results.",
      },
      {
        label: "Effortless Service",
        text: "From easy online booking to fast, reliable delivery, we make laundry and dry cleaning convenient and stress-free.",
      },
      {
        label: "Exceptional Value",
        text: "Get top-tier care without the premium price tag—luxury service at a price you'll love.",
      },
      {
        label: "Expert Care",
        text: "With years of experience, our skilled professionals handle every fabric with precision, ensuring your items are returned in pristine condition.",
      },
      {
        label: "Total Convenience",
        text: "We work around your schedule with 24/7 availability and quick turnaround times, so you can focus on what matters most.",
      },
      {
        label: "Pristine Cleanliness",
        text: "We adhere to the highest hygiene standards, ensuring your clothes are not just clean, but meticulously sanitized and fresh.",
      },
    ],
    [
      {
        label: "Integrity",
        text: "Transparent pricing, no hidden fees, and service you can trust—every time.",
      },
      {
        label: "Attention to Detail",
        text: "Every stitch, every fabric, every piece is treated with the utmost care and precision.",
      },
      {
        label: "Customer Delight",
        text: "We're not satisfied until you are. Our goal is to exceed your expectations, every time.",
      },
    ],
    [
      {
        label: "Honesty",
        text: "We uphold a straightforward approach, ensuring clear communication and no hidden charges.",
      },
      {
        label: "Transparency",
        text: "We provide clear information about our processes and pricing, so you know exactly what to expect.",
      },
      {
        label: "Excellence",
        text: "We are dedicated to maintaining the highest standards in every aspect of our work.",
      },
      {
        label: "Reliability",
        text: "Our commitment to punctuality and consistency means you can depend on us to deliver on time, every time.",
      },
      {
        label: "Respect",
        text: "We handle each garment with the utmost respect, acknowledging the personal value each item requires.",
      },
      {
        label: "Sustainability",
        text: "We actively pursue eco-friendly practices, from energy-efficient operations to environmentally conscious products.",
      },
      {
        label: "Customer Focus",
        text: "We prioritize your needs and preferences, tailoring our services to ensure a personalized experience.",
      },
      {
        label: "Innovation",
        text: "Embracing the latest technologies and methods, we continually enhance our services to provide cutting-edge solutions.",
      },
    ],
  ];

  return (
    <section
      className="s3feat"
      style={{
        background:
          /*  section?.section_bg_color */ 'background: "rgb(44, 86, 94)',
      }}
    >
      <div className="container">
        {/* Section header */}
        <div className="s3feat__head">
          {section?.sub_heading_top && (
            <span
              className="s3feat__eyebrow"
              style={{ background: section?.eyebrow_color }}
            >
              {section.sub_heading_top}
            </span>
          )}
          <h2
            className="s3feat__title"
            style={{
              color: section?.h2color
                ? /* `#${section.h2color}`  */ "white"
                : "#fff",
            }}
          >
            {section?.title}
          </h2>
          {section?.paragraph && (
            <p
              className="s3feat__para"
              style={{
                color: section?.paracolor
                  ? /*  `#${section.paracolor}` */ "#fff"
                  : "#fff",
              }}
            >
              {section.paragraph}
            </p>
          )}
        </div>

        {/* Cards */}
        <div className="row">
          {isMydhobi ? (
            collection.map((item: any, index: number) => (
              <div className="col-md-4" key={index}>
                <div className="s3feat__card">
                  <span className="s3feat__card-num">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                  <div
                    className="s3feat__card-icon"
                    style={{
                      background: section?.eyebrow_color
                        ? `${section.eyebrow_color}18`
                        : undefined,
                    }}
                  >
                    <img src={item.icon} alt={item.collection_title} />
                  </div>
                  <h3
                    className="s3feat__card-title"
                    style={{
                      color: section?.h3color
                        ? `#${section.h3color}`
                        : undefined,
                    }}
                  >
                    {item.collection_title}
                  </h3>
                  <ul className="s3feat__card-list">
                    {(mydhobiContent[index] || []).map((point, pi) => (
                      <li key={pi}>
                        <strong>{point.label}:</strong> {point.text}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))
          ) : (
            <div className="col-12">
              <Swiper
                spaceBetween={24}
                slidesPerView={1}
                loop={true}
                navigation={true}
                autoplay={{ delay: 2500, disableOnInteraction: false }}
                modules={[Navigation, Autoplay]}
                breakpoints={{
                  0: { slidesPerView: 1 },
                  640: { slidesPerView: 2 },
                  1024: { slidesPerView: 3 },
                }}
                className="home-slider"
              >
                {collection.map((item: any, index: number) => (
                  <SwiperSlide key={index}>
                    <div className="s3feat__card">
                      <span className="s3feat__card-num">
                        {String(index + 1).padStart(2, "0")}
                      </span>
                      <div
                        className="s3feat__card-icon"
                        style={{
                          background: section?.eyebrow_color
                            ? `${section.eyebrow_color}18`
                            : undefined,
                        }}
                      >
                        <img src={item.icon} alt={item.collection_title} />
                      </div>
                      <h3
                        className="s3feat__card-title"
                        style={{
                          color: section?.h3color
                            ? `#${section.h3color}`
                            : undefined,
                        }}
                      >
                        {item.collection_title}
                      </h3>
                      <p
                        className="s3feat__card-para"
                        style={{
                          color: section?.paracolor
                            ? `#${section.paracolor}`
                            : undefined,
                        }}
                      >
                        {item.collection_paragraph}
                      </p>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

export default SectionThreeThemeThree;
